export const meta: BlockMeta = {
  title: "Grid Rows Item",
  description: "A single grid row item",
  keywords: ["content"],
  icon: "book-alt",
  category: "layouts",
}

import { defineBlock, InnerBlocks } from "eddev/blocks"

export default defineBlock("content/grid-rows-item", (props) => {
  return (
    <div className="[&_p]:py-1">
      <InnerBlocks
        allowedBlocks={["core/paragraph"]}
        template={[["core/paragraph", { placeholder: "Enter text" }]]}
        orientation="vertical"
      />
    </div>
  )
})
